<!--店铺商品管理-->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog()">查询（F2）</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.batchUp"
                    @click="batchUpOrDownGoods(0)">{{ permission.batchUp }}</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.batchDown"
                    @click="batchUpOrDownGoods(1)">{{ permission.batchDown }}</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.exportImg"
                    @click="downGoodsImg()">{{ permission.exportImg }}</el-button>
                <el-button size="small" class="search-btn" type="warning" v-if="permission.batchDelGoodsRs"
                    @click="batchDelShopGoodsRs()">{{ permission.batchDelGoodsRs }}</el-button>
            </div>
            <div>当前店铺：{{ title }}</div>
        </div>
        <template>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" ref="goodsTable"
                    @selection-change="handleSelectionChange" @cell-dblclick="handleDBClick" :tableCode="tableCode"
                    border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <template v-for="(col, index) in columnShowSets">
                        <el-table-column v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                            :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'APCode'" show-overflow-tooltip fixed="left">
                            <template slot="header">
                                {{ col.ColumnName }}
                            </template>
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.MainImg" icon="el-icon-picture" type="text"
                                    @click="getGoodsImages(scope.row.GoodsId)"></el-button>
                                {{ scope.row.APCode }}
                            </template>
                        </el-table-column>
                        <el-table-column v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                            :prop="col.ColumnCode" v-else-if="col.ColumnCode == 'IsUp'" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div style="color: orange;" v-if="scope.row.IsUp">已上架</div>
                                <div v-else>未上架</div>
                            </template>
                        </el-table-column>
                        <el-table-column v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                            :prop="col.ColumnCode" class-name="pgcode-column"
                            v-else-if="col.ColumnCode == 'PGoodsCode'">
                            <template slot-scope="scope">
                                <div v-if="!scope.row.IsEdit" style="width: 100%;height: 24px;"
                                    @click="editPGoodsCode(scope.$index)">{{ scope.row.PGoodsCode }}</div>
                                <div v-else>
                                    <el-input class="table-item" @blur="handlePGoodsCodeBlur(scope.$index)"
                                        @keyup.enter="handlePGoodsCodeBlur(scope.$index)" maxlength="20"
                                        :ref="`pgoods-input-${scope.$index}`" size="small"
                                        v-model="scope.row.PGoodsCode" placeholder="请输入"></el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'" :label="col.ColumnName" resizable
                            :sortable="col.IsSort ? 'custom' : false" header-align :prop="col.ColumnCode"
                            show-overflow-tooltip v-else>
                        </el-table-column>
                    </template>
                    <el-table-column fixed="right" label="操作" :isCanSet="true" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="编辑" size="mini" type="text"
                                    v-if="permission.upGoods && !scope.row.IsUp"
                                    @click="upOrDownGoods(scope.row, scope.$index)">{{ permission.upGoods }}</el-button>
                                <el-button size="mini" @click="upOrDownGoods(scope.row, scope.$index)"
                                    style="color: orange;" v-if="permission.downGoods && scope.row.IsUp" type="text">{{
                                        permission.downGoods }}</el-button>
                                <el-button size="mini" @click="delShopGoodsRs(scope.row)" style="color: red;"
                                    v-if="permission.delGoodsRs" type="text">{{ permission.delGoodsRs }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"></el-pagination>
            </div>

            <el-dialog :close-on-click-modal="false" title="库存商品搜索" :visible.sync="dialogVisible" width="400px"
                append-to-body v-dialog-drag lock-scroll :modal="false" id="search-goods-dialog"
                custom-class="search-item-dialog" style="margin-left: -170px">
                <div class="dialog-content" v-if="dialogVisible">
                    <el-form ref="form" label-position="left" label-width="90px">
                        <el-form-item :label="searchShowSets.JointSearch.Title"
                            v-if="searchShowSets.JointSearch.IsShow">
                            <el-input ref="search_0" class="search-item" size="small" v-model="searchData.JointSearch"
                                :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'"></el-input>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.APCode.Title" v-if="searchShowSets.APCode.IsShow">
                            <el-autocomplete ref="search_1" size="small" style="width: 100%" v-model="searchData.APCode"
                                :fetch-suggestions="searchAPCode" :debounce="500" placeholder="请输入汽配编码"
                                :trigger-on-focus="false" @select="stopSearch"
                                v-scrollLoad="searchAPCodeLoad"></el-autocomplete>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.GoodName.Title" v-if="searchShowSets.GoodName.IsShow">
                            <el-autocomplete ref="search_2" size="small" style="width: 100%"
                                v-model="searchData.GoodName" :fetch-suggestions="searchGoodName" :debounce="500"
                                placeholder="请输入汽配名称" :trigger-on-focus="false" @select="stopSearch"
                                v-scrollLoad="searchGoodNameLoad"></el-autocomplete>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.AutoSerise.Title" v-if="searchShowSets.AutoSerise.IsShow">
                            <el-autocomplete ref="search_3" size="small" style="width: 100%" :debounce="500"
                                v-model="searchData.AutoSerise" :fetch-suggestions="searchAutoSerise"
                                placeholder="请输入车型" :trigger-on-focus="false" @select="stopSearch"
                                v-scrollLoad="searchAutoSeriseLoad"></el-autocomplete>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.Brand.Title" v-if="searchShowSets.Brand.IsShow">
                            <el-select ref="search_4" v-model="searchData.BrandName" multiple collapse-tags filterable
                                clearable size="small" style="width: 100%" @visible-change="brandVisibleChange($event)">
                                <el-option :key="item.Text" v-for="item in brand" :label="item.Text"
                                    :value="item.Text"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.Cate.Title" v-if="searchShowSets.Cate.IsShow">
                            <el-select ref="search_5" size="small" style="width: 100%" v-model="searchData.Cate"
                                multiple collapse-tags filterable clearable @visible-change="cateVisibleChange($event)">
                                <el-option v-for="optionItem in typeList" :key="optionItem.Value"
                                    :label="optionItem.Text" :value="optionItem.Value">
                                    <div class="option-content">
                                        <div>{{ optionItem.Text }}</div>
                                    </div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.Size.Title" v-if="searchShowSets.Size.IsShow">
                            <el-input @focus="selectAutoHandle('search_6')" ref="search_6" class="search-item"
                                size="small" v-model="searchData.Size" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.ExAttribute6.Title"
                            v-if="searchShowSets.ExAttribute6.IsShow">
                            <el-input @focus="selectAutoHandle('search_7')" ref="search_7" class="search-item"
                                size="small" v-model="searchData.ExAttribute6" placeholder="请输入英文车型"></el-input>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.IsUp.Title" v-if="searchShowSets.IsUp.IsShow">
                            <el-select ref="search_8" size="small" style="width: 100%" v-model="searchData.IsUp"
                                filterable clearable>
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已上架" value="1"></el-option>
                                <el-option label="未上架" value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.PGoodsCode.Title" v-if="searchShowSets.PGoodsCode.IsShow">
                            <el-input ref="search_9" class="search-item" size="small" v-model="searchData.PGoodsCode"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.Texture.Title" v-if="searchShowSets.Texture.IsShow">
                            <el-input ref="search_10" class="search-item" size="small" v-model="searchData.Texture"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item :label="searchShowSets.UpdateTime.Title" v-if="searchShowSets.UpdateTime.IsShow">
                            <el-date-picker size="small" style="width: 100%" v-model="datetime1" type="daterange"
                                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="pickerOptions"
                                @change="onDateTimeSelect"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="查询公式">
                            <el-radio-group v-model="searchData.SearchType">
                                <el-radio :label="0">左等</el-radio>
                                <el-radio :label="1">全等</el-radio>
                                <el-radio :label="2">包含</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                        <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                        <el-button size="small" icon="el-icon-setting" class="search-btn" type="primary"
                            v-if="permission.advancedSearch" @click="searchSets">{{
                                permission.advancedSearch
                            }}</el-button>
                    </div>
                </div>
            </el-dialog>

            <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
                <div v-if="APMsgVisible">
                    <APMsg_ec :EntpTempGoodsId="Id" @closeDialog="closeAPMsgDialog"></APMsg_ec>
                </div>
            </el-dialog>
            <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />

        </template>
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog"
            :visible.sync="searchSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="searchSetVisible">
                <searchSets :tableCode="tableCode" @closeDialog="closeDialog"></searchSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
import elTableColumn from '@/components/common/chjtablecolumn';
import APMsg_ec from '@/components/business/ecPlatform/apMsg_ec';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import searchSets from '@/components/common/searchSets.vue';

export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: { elTableColumn, breadcrumb, ElImageViewer, APMsg_ec, searchSets },
    data() {
        return {
            showViewer: false,
            APMsgVisible: false,
            tableCode: 'EC-ShopsGoods',
            columnShowSets: [],
            eidtGoodsId: '', //用于记录编辑的哪个商品，双击的时候不会打开弹窗
            eidtPGCode: '', //如果没有改平台编码就不用请求接口
            searchSetVisible: false,
            srcList: [],
            noData: false,
            loading: false,
            downloadUrl: this.$util.QN_URL_BASE,
            Id: '',
            title: '',
            searchData: {
                JointSearch: '',
                ShopId: '',
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                IsCheck: '',
                Texture: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                PGoodsCode: '',
                page: 1,
                limit: 15,
                SearchType: 2,
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            multipleSelection: [],
            dialogVisible: false,
            isStartSearch: false,
            searchIndex: 0,
            brand: [],
            typeList: [],
            canSearch: true,
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            searchShowSets: {
                JointSearch: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                APCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                GoodName: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                AutoSerise: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Brand: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Cate: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: ''
                },
                Size: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                Texture: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                ExAttribute6: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                IsUp: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                PGoodsCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                },
                UpdateTime: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: '',
                    Width: 0
                }
            },
            datetime1: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
        };
    },
    created() {
        this.getJointSearchSets();
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.searchData.ShopId = this.$route.query.ShopId;
        this.title = this.$route.query.Platform + "平台 【" + this.$route.query.ShopName + "】";

        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSetsData();
        this.getSearchCrtSetsData();
        this.getTableData();
        this.permission = this.$util.getPermission('ecShopDetailManage');
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    if (this.$refs.search_0) {
                        this.$refs.search_0.focus();
                        this.searchIndex = 0;
                    }
                });
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            //按下一页、上一页、重新查询的时候，停下子接口的查询
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                that.isStartSearch = true;
            }
            //Enter
            if (key === 13) {
                if (that.dialogVisible) {
                    e.preventDefault();
                    if (
                        (!that.$refs.search_4 || !that.$refs.search_4.visible) &&
                        (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                        (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                        (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                        (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                        (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                        (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible) &&
                        that.canSearch
                    ) {
                        that.handleSearch();
                    }
                    that.canSearch = true;
                    that.isStartSearch = false;
                }
            }
            //ESC
            if (key === 27) {
                that.canSearch = true;
                that.showViewer = false;
                if (
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible)
                ) {
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.dialogVisible) {
                    that.dialogVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                if (!this.dialogVisible) {
                    e.preventDefault();
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //左键
            if (key === 37) {
                if (!that.dialogVisible) {
                    e.preventDefault();
                    if (that.searchData.page !== 1) {
                        that.isStopChildReq = true;
                        that.isStartSearch = false;
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                    return;
                }
            }
            //下键
            if (key == 40) {
                that.canSearch = true;
                e.preventDefault();
                if (that.dialogVisible) {
                    if (that.searchIndex != 8) {
                        if (
                            (!that.$refs.search_4 || !that.$refs.search_4.visible) &&
                            (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                            (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                            (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                            (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                            (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                            (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                        ) {
                            if (that.searchIndex == 4 || that.searchIndex == 5) {
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                            }
                            that.searchIndex += 1;
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                        }
                    }
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                e.preventDefault();
                if (that.dialogVisible) {
                    if (that.searchIndex != 0) {
                        if (
                            (!that.$refs.search_4 || !that.$refs.search_4.visible) &&
                            (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                            (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                            (!that.$refs.search_7 || !that.$refs.search_7.visible) &&
                            (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                            (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                            (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                        ) {
                            if (that.searchIndex == 4 || that.searchIndex == 5) {
                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                            }
                            that.searchIndex -= 1;
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                        }
                    }
                }
                return;
            }
        },
        getTableData() {
            this.eidtGoodsId = '';
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetShopGoodsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => { });
        },
        upOrDownGoods(row, index) {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/UpOrDownShopGoods',
                    data: { UpRsId: row.Id }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);

                        this.tableData[index].IsUp = !row.IsUp;
                        this.tableData = this.tableData.sort((a, b) => {

                            if (a.IsUp && !b.IsUp) return 1;
                            if (!a.IsUp && b.IsUp) return -1;
                            return 0;
                        });
                        // this.handleSearch();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        batchUpOrDownGoods(type) {
            if (this.multipleSelection.length == 0) {
                this.$util.warningMsg("请先选择要上架的商品！")
                return false;
            }

            var arr = this.multipleSelection.filter(x => type == 0 ? !x.IsUp : x.IsUp).map(x => x.Id)

            ///用来记日志的
            var arr2 = this.multipleSelection.filter(x => type == 0 ? !x.IsUp : x.IsUp).map(x => x.GoodsId)

            if (arr.length == 0) {
                this.$util.warningMsg("请选择正确的数据！");
                return false;
            }

            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/BatchUpOrDownGoods',
                    data: { ShopId: this.searchData.ShopId, UpRsIds: arr, GoodsIds: arr2, page: type } //这里page是类型的意思是上架或下架 0 上 1下
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.getTableData();
                        this.clearTableSelection();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        delShopGoodsRs(row) {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/delShopGoodsRs',
                    data: { UpRsId: row.Id }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.handleSearch();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        batchDelShopGoodsRs() {
            if (this.multipleSelection.length == 0) {
                this.$util.warningMsg("请先选择要移除的商品！")
                return false;
            }
            var arr = this.multipleSelection.map(x => x.Id)

            ///用来记日志的
            var arr2 = this.multipleSelection.map(x => x.GoodsId)

            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/BatchDelShopGoodsRs',
                    data: { ShopId: this.searchData.ShopId, UpRsIds: arr, GoodsIds: arr2 }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.handleSearch();
                        this.clearTableSelection();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        downGoodsImg() {
            if (this.multipleSelection.length != 1) {
                this.$util.warningMsg("只能选择一个商品数据！");
                return false;
            }
            this.loading = true;
            var goods = this.multipleSelection[0];
            this.$util
                .axiosPost({
                    url: '/api/EntpGoods/DownGoodsImg',
                    data: { GoodsId: goods.GoodsId }
                })
                .then(res => {
                    if (res.errcode == 0) {

                        if (res.data.length == 0) {
                            this.$util.warningMsg("该商品暂无图片！");
                            return false;
                        }

                        for (let i = 0; i < res.data.length; i++) {
                            const imgUrl = this.downloadUrl + res.data[i];
                            const fileName = goods.APCode + "(" + (i + 1) + ').png'; // 必须包含扩展名
                            this.downloadImage(imgUrl, fileName);
                        }
                        this.clearTableSelection();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        //表单双击事件
        handleDBClick(event) {

            if (event.GoodsId && (this.eidtGoodsId ? this.eidtGoodsId != event.GoodsId : true)) {
                this.showAPMsgDialog(event.GoodsId);
            }
        },
        // 配件信息
        showAPMsgDialog(id) {
            this.Id = id;
            this.APMsgVisible = true;
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        // downloadImage(imageUrl, fileName) {
        //     const a = document.createElement('a');
        //     a.href = imageUrl;
        //     a.download = fileName;
        //     a.click();
        //     a.remove();
        // },
        downloadImage(imageUrl, fileName) {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                canvas.toBlob(blob => {

                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    // 触发点击下载
                    a.click();
                    URL.revokeObjectURL(url);

                }, 'image/png');
            };

            img.onerror = () => {
                this.$util.errorMsg('图片下载失败，请检查链接是否有效');
            };
            img.src = imageUrl;
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        clearTableSelection() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = [];
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            let callback = cb;
            if (this.apCodeForm.stopLoad) return;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (callback) {
                    callback(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            let callback = cb;
            if (this.goodNameForm.stopLoad) return;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (callback) {
                    callback(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            let callback = cb;
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (callback) {
                    callback(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        stopSearch() {
            this.canSearch = false;
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        searchGoodsBrand() {
            if (this.brand.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .finally(() => { });
        },
        searchGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => { });
        },
        // 重置表单
        resetSearch() {
            let sId = this.searchData.ShopId;
            this.searchData
            this.searchData = {
                JointSearch: '',
                ShopId: sId,
                AutoSerise: '',
                Size: '',
                APCode: '',
                BrandName: [],
                GoodName: '',
                Cate: [],
                SortProp: '',
                SortType: '',
                IsCheck: '',
                Texture: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                PGoodsCode: '',
                page: 1,
                limit: 15,
                SearchType: 2,
            };
            this.datetime1 = [];
            this.datetime2 = [];
            if (this.isSpaceSet) {
                this.searchData.SpaceType = ['0', '1'];
            }
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        closeViewer() {
            this.showViewer = false;
        },
        async getGoodsImages(goodsId) {
            this.srcList = [];
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsImages',
                data: { goodsId: goodsId }
            });
            if (data) {
                this.srcList = data;
            }
            this.showViewer = true;
        },
        editPGoodsCode(index) {
            this.tableData.forEach((row, idx) => {
                if (idx !== index) {
                    row.IsEdit = false;
                    // 移除其他行PGoodsCode列的清除内边距类名
                    this.removeCellPaddingClass(idx);
                }
            });

            // 设置当前行编辑状态
            this.eidtGoodsId = this.tableData[index].GoodsId;
            this.eidtPGCode = this.tableData[index].PGoodsCode;
            this.tableData[index].IsEdit = true;

            // 给当前行PGoodsCode列的单元格添加清除内边距的类名
            this.addCellPaddingClass(index);

            this.$nextTick(() => {
                const inputRef = this.$refs[`pgoods-input-${index}`];
                if (inputRef) {
                    inputRef[0].focus();
                }
            });
        },
        addCellPaddingClass(rowIndex) {
            this.$nextTick(() => {
                // 获取表格行元素
                const rowEl = this.$refs.goodsTable.$el.querySelectorAll('.el-table__row')[rowIndex];
                if (rowEl) {
                    // 找到PGoodsCode列的单元格（pgcode-column类名）
                    const cellEl = rowEl.querySelector('.pgcode-column');
                    if (cellEl) {
                        cellEl.classList.add('pgcode-cell-no-padding');
                    }
                }
            });
        },
        // 移除指定行的PGoodsCode列单元格清除内边距类名
        removeCellPaddingClass(rowIndex) {
            this.$nextTick(() => {
                const rowEl = this.$refs.goodsTable.$el.querySelectorAll('.el-table__row')[rowIndex];
                if (rowEl) {
                    const cellEl = rowEl.querySelector('.pgcode-column');
                    if (cellEl) {
                        cellEl.classList.remove('pgcode-cell-no-padding');
                    }
                }
            });
        },

        handlePGoodsCodeBlur(index) {
            var data = this.tableData[index];
            if (this.eidtPGCode == data.PGoodsCode) {
                this.tableData[index].IsEdit = false;
                this.eidtPGCode = '';
                this.eidtGoodsId = '';
                this.removeCellPaddingClass(index);
                return false;
            }
            if (!data) {
                this.$util.successMsg("数据有误请刷新后重试！");
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].IsEdit = false;
                }
                this.eidtPGCode = '';
                this.eidtGoodsId = '';
                return false;
            }
            if (!data.PGoodsCode) {
                this.eidtPGCode = '';
                this.eidtGoodsId = '';
                this.tableData[index].IsEdit = false;
                return false;
            }
            if (data.PGoodsCode.length > 20) {
                this.$util.warningMsg("平台编码过长！");
                return false;
            }
            this.loading = true;

            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/SavePlatformGoodsCode',
                    data: { Id: data.Id, Key: data.PGoodsCode }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.tableData[index].IsEdit = false;
                        this.eidtPGCode = '';
                        this.eidtGoodsId = '';
                        this.removeCellPaddingClass(index);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        searchSets() {
            if (this.tableCode) {
                this.searchSetVisible = true;
            }
        },
        closeDialog(isEdit) {
            this.searchSetVisible = false;
            if (isEdit) {
                this.$util.refresh();
            }
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData(this.tableCode, false).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'JointSearch':
                            this.searchShowSets.JointSearch.IsShow = item.IsShow;
                            this.searchShowSets.JointSearch.Width = item.Width;
                            this.searchShowSets.JointSearch.Placeholder = item.Placeholder;
                            this.searchShowSets.JointSearch.Title = item.Title;
                            this.searchShowSets.JointSearch.SortNum = item.SortNum;
                            break;
                        case 'APCode':
                            this.searchShowSets.APCode.IsShow = item.IsShow;
                            this.searchShowSets.APCode.Width = item.Width;
                            this.searchShowSets.APCode.Placeholder = item.Placeholder;
                            this.searchShowSets.APCode.Title = item.Title;
                            this.searchShowSets.APCode.SortNum = item.SortNum;
                            break;
                        case 'GoodName':
                            this.searchShowSets.GoodName.IsShow = item.IsShow;
                            this.searchShowSets.GoodName.Width = item.Width;
                            this.searchShowSets.GoodName.Placeholder = item.Placeholder;
                            this.searchShowSets.GoodName.Title = item.Title;
                            this.searchShowSets.GoodName.SortNum = item.SortNum;
                            break;
                        case 'AutoSerise':
                            this.searchShowSets.AutoSerise.IsShow = item.IsShow;
                            this.searchShowSets.AutoSerise.Width = item.Width;
                            this.searchShowSets.AutoSerise.Placeholder = item.Placeholder;
                            this.searchShowSets.AutoSerise.Title = item.Title;
                            this.searchShowSets.AutoSerise.SortNum = item.SortNum;
                            break;
                        case 'Brand':
                            this.searchShowSets.Brand.IsShow = item.IsShow;
                            this.searchShowSets.Brand.Width = item.Width;
                            this.searchShowSets.Brand.Placeholder = item.Placeholder;
                            this.searchShowSets.Brand.Title = item.Title;
                            this.searchShowSets.Brand.SortNum = item.SortNum;
                            break;
                        case 'Cate':
                            this.searchShowSets.Cate.IsShow = item.IsShow;
                            this.searchShowSets.Cate.Width = item.Width;
                            this.searchShowSets.Cate.Placeholder = item.Placeholder;
                            this.searchShowSets.Cate.Title = item.Title;
                            this.searchShowSets.Cate.SortNum = item.SortNum;
                            break;
                        case 'Texture':
                            this.searchShowSets.Texture.IsShow = item.IsShow;
                            this.searchShowSets.Texture.Width = item.Width;
                            this.searchShowSets.Texture.Placeholder = item.Placeholder;
                            this.searchShowSets.Texture.Title = item.Title;
                            this.searchShowSets.Texture.SortNum = item.SortNum;
                            break;
                        case 'Size':
                            this.searchShowSets.Size.IsShow = item.IsShow;
                            this.searchShowSets.Size.Width = item.Width;
                            this.searchShowSets.Size.Placeholder = item.Placeholder;
                            this.searchShowSets.Size.Title = item.Title;
                            this.searchShowSets.Size.SortNum = item.SortNum;
                            break;
                        case 'ExAttribute6':
                            this.searchShowSets.ExAttribute6.IsShow = item.IsShow;
                            this.searchShowSets.ExAttribute6.Width = item.Width;
                            this.searchShowSets.ExAttribute6.Placeholder = item.Placeholder;
                            this.searchShowSets.ExAttribute6.Title = item.Title;
                            this.searchShowSets.ExAttribute6.SortNum = item.SortNum;
                            break;
                        case 'IsUp':
                            this.searchShowSets.IsUp.IsShow = item.IsShow;
                            this.searchShowSets.IsUp.Width = item.Width;
                            this.searchShowSets.IsUp.Placeholder = item.Placeholder;
                            this.searchShowSets.IsUp.Title = item.Title;
                            this.searchShowSets.IsUp.SortNum = item.SortNum;
                            break;
                        case 'UpdateTime':
                            this.searchShowSets.UpdateTime.IsShow = item.IsShow;
                            this.searchShowSets.UpdateTime.Width = item.Width;
                            this.searchShowSets.UpdateTime.Placeholder = item.Placeholder;
                            this.searchShowSets.UpdateTime.Title = item.Title;
                            this.searchShowSets.UpdateTime.SortNum = item.SortNum;
                            break;
                        case 'PGoodsCode':
                            this.searchShowSets.PGoodsCode.IsShow = item.IsShow;
                            this.searchShowSets.PGoodsCode.Width = item.Width;
                            this.searchShowSets.PGoodsCode.Placeholder = item.Placeholder;
                            this.searchShowSets.PGoodsCode.Title = item.Title;
                            this.searchShowSets.PGoodsCode.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
    }
};
</script>
<style lang="less" scoped>
// /deep/ .el-table .el-table__body .el-table__row .el-table__cell.pgcode-column {
//   // 清除单元格默认内边距
//   padding: 2px !important;
// }
// /deep/.PGoodsCode-column .cell{
//   padding: 0 !important;
// }
/deep/ .pgcode-cell-no-padding .cell{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
#search-goods-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.table-ctn1 {
    max-height: 240px;
    overflow: auto;
    border-bottom: solid 1px #F2F6FC;
}

.sf-page {
    margin-top: 20px;
}

@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}

@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.el-table .error-row {
    background: rgb(255, 176, 176);
}
</style>
